<div
  [ngClass]="{
    'content-register': !showMessage,
    'content-register2': showMessage
  }"
  class="content-register"
>
  <div class="register-form">
    <div *ngIf="!showMessage">
      <div class="mb-4">
        <p class="text-medium text-secondary text-bold">
          Registro de Proveedor
        </p>
        <div class="text-subtitle">
          <p class="text-medium text-secondary mt-2">
            Completa la información para crear tu cuenta de usuario.
          </p>
        </div>
      </div>
      <div class="mb-5 pt-2">
        <form
          [formGroup]="formulario_registro_alianza"
          (ngSubmit)="createProvider()"
        >
          <div class="input-field">
            <select
              class="form-control"
              (change)="typePerson($event.target.value)"
            >
              <option value="1">Persona Física</option>
              <option value="2">Persona Moral</option>
            </select>
          </div>

          <!-- FORMULARIO PERSONA FISICA -->
          <div *ngIf="persona == 1">
            <div class="input-field">
              <input
                type="text"
                class="form-control text-upper"
                placeholder="RFC (*)"
                name="rfc"
                required
                [maxlength]="persona == 1 ? 13 : 12"
                formControlName="rfcFisica"
                onkeypress="return ((event.keyCode >= 48 && event.keyCode <=57) || (event.keyCode >=65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122)  || (event.keyCode == 209) || (event.keyCode == 241)) "
              />
              <div
                *ngIf="
                  formulario_registro_alianza.controls['rfcFisica'].invalid &&
                  formulario_registro_alianza.controls['rfcFisica'].touched
                "
              >
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['rfcFisica'].errors
                      ?.required
                  "
                >
                  Campo obligatorio *
                </small>
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['rfcFisica'].errors
                      ?.minlength
                  "
                >
                  RFC no válido
                </small>
              </div>
            </div>
            <div class="input-field">
              <input
                type="text"
                class="form-control"
                placeholder="Primer Nombre (*)"
                name="primerNombre"
                required
                maxlength="40"
                formControlName="primerNombre"
                onkeypress="return ( (event.keyCode >= 65) && (event.keyCode <= 90) || (event.keyCode >= 97) && (event.keyCode <= 122) || (event.keyCode == 209) || (event.keyCode == 241) )"
              />
              <div
                *ngIf="
                  formulario_registro_alianza.controls['primerNombre']
                    .invalid &&
                  formulario_registro_alianza.controls['primerNombre'].touched
                "
              >
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['primerNombre'].errors
                      ?.required
                  "
                >
                  Campo obligatorio *
                </small>
              </div>
            </div>
            <div class="input-field">
              <input
                type="text"
                class="form-control"
                placeholder="Primer Apellido (*)"
                name="primerApellido"
                required
                maxlength="40"
                formControlName="primerApellido"
                onkeypress="return ( (event.keyCode >= 65) && (event.keyCode <= 90) || (event.keyCode >= 97) && (event.keyCode <= 122) || (event.keyCode == 209) || (event.keyCode == 241) )"
              />
              <div
                *ngIf="
                  formulario_registro_alianza.controls['primerApellido']
                    .invalid &&
                  formulario_registro_alianza.controls['primerApellido'].touched
                "
              >
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['primerApellido']
                      .errors?.required
                  "
                >
                  Campo obligatorio *
                </small>
              </div>
            </div>

            <div class="input-field">
              <app-date-picker
                placeholder="Fecha de Nacimiento (*)"
                [max]="hoy"
                [dateString]="dateString"
                (action)="dateText($event, persona)"
              ></app-date-picker>
            </div>
            <small
              *ngIf="!fecha_valida && fecha_tocada"
              class="text-danger ml-2"
            >
              Fecha de nacimiento no válida
            </small>

            <small *ngIf="edad < 18 && fecha_valida" class="ml-2 text-danger"
              >Debe ser mayor de edad</small
            >

            <div class="form-group">
              <select
                style="
                  visibility: hidden;
                  position: absolute;
                  z-index: -100;
                  width: 0px;
                "
                name="nacionalidad"
                class="form-control"
              >
                <option value="" selected>Nacionalidad</option>

                <option
                  *ngFor="let nacionalidad of nacionalidades; let i = index"
                  [value]="nacionalidad.code"
                >
                  {{ nacionalidad.desc }}
                </option>
              </select>
              <div class="form-group" style="margin-top: 10px">
                <ng-selectize
                  name="selectNacionalidad"
                  [value]="''"
                  [config]="singleSelectConfig"
                  [options]="nacionalidades"
                  [placeholder]="'Nacionalidad'"
                  [formControl]="f.nacionalidad"
                  (click)="changeSelectSearch(f.nacionalidad)"
                  ngDefaultControl
                ></ng-selectize>
                <small
                  *ngIf="f.nacionalidad.invalid && f.nacionalidad.touched"
                  class="ml-2 text-danger"
                  >Nacionalidad no válida</small
                >
              </div>
            </div>

            <div class="input-field">
              <input
                type="email"
                class="form-control"
                placeholder="Correo electrónico (*)"
                name="email"
                required
                formControlName="email"
              />
              <div
                *ngIf="
                  formulario_registro_alianza.controls['email'].invalid &&
                  formulario_registro_alianza.controls['email'].touched
                "
              >
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['email'].errors
                      ?.required
                  "
                >
                  Campo obligatorio *
                </small>
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['email'].errors?.email
                  "
                >
                  Correo Electrónico no válido
                </small>
              </div>
            </div>
            <div class="input-field">
              <div class="input-icon-password">
                <div
                  class="help-password"
                  title="Su contraseña debe contener mínimo 8 caracteres, letras &#013;mayúscula y minúsculas, un número y un caracter especial (#?!@$%^&*-). &#013;Ejemplo:Prueba1@"
                >
                  <i class="fas fa-question-circle"></i>
                </div>
                <i
                  *ngIf="!show"
                  class="fas fa-eye-slash lock"
                  (click)="switchPass()"
                ></i>
                <i
                  *ngIf="show"
                  class="fas fa-eye lock"
                  (click)="switchPass()"
                ></i>
                <input
                  [type]="show ? 'text' : 'password'"
                  type="password"
                  class="form-control"
                  placeholder="Contraseña (*)"
                  required
                  name="password1"
                  formControlName="password1"
                  (ngModelChange)="confirmPassword($event)"
                />
              </div>
              <div
                *ngIf="
                  formulario_registro_alianza.controls['password1'].touched &&
                  formulario_registro_alianza.controls['password1'].invalid
                "
              >
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['password1'].errors
                      ?.required
                  "
                >
                  Campo obligatorio *
                </small>
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['password1'].errors
                      ?.minlength
                  "
                >
                  Mínimo 8 caracteres *
                </small>
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['password1'].errors
                      ?.pattern
                  "
                >
                  Contraseña no válida *
                </small>
              </div>
            </div>
            <div class="input-field">
              <div class="input-icon-password">
                <i
                  *ngIf="!show"
                  class="fas fa-eye-slash lock"
                  (click)="switchPass()"
                ></i>
                <i
                  *ngIf="show"
                  class="fas fa-eye lock"
                  (click)="switchPass()"
                ></i>
                <input
                  [type]="show ? 'text' : 'password'"
                  type="password"
                  class="form-control"
                  placeholder="Repetir Contraseña (*)"
                  required
                  name="password2"
                  minlength="8"
                  formControlName="password2"
                  (ngModelChange)="confirmPassword($event)"
                />
              </div>
              <div
                *ngIf="
                  formulario_registro_alianza.controls['password2'].touched &&
                  formulario_registro_alianza.controls['password2'].invalid
                "
              >
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['password2'].errors
                      ?.required
                  "
                >
                  Campo obligatorio *
                </small>
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['password2'].errors
                      ?.minlength
                  "
                >
                  Mínimo 8 caracteres *
                </small>
              </div>
              <div
                *ngIf="
                  formulario_registro_alianza.controls['password2'].touched
                "
              >
                <small class="text-danger ml-2 mb-2" *ngIf="!iguales">
                  Las contraseñas deben coincidir
                </small>
              </div>
            </div>

            <div class="mt-2">
              <input
                type="checkbox"
                formControlName="actividadComercial"
                (change)="switchChange()"
              />
              Persona física con actividad comercial
            </div>

            <div
              *ngIf="
                formulario_registro_alianza.controls['actividadComercial'].value
              "
            >
              <div class="input-field">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nombre Comercial (*)"
                  onkeypress="return ((event.keyCode >= 65) && (event.keyCode <= 90) || (event.keyCode >= 97) && (event.keyCode <= 122) || (event.keyCode == 209) || (event.keyCode == 241) || (event.keyCode == 32) ) "
                  name="nombreComercial"
                  maxlength="100"
                  formControlName="nombreComercial"
                />
              </div>
              <small
                *ngIf="
                  formulario_registro_alianza.controls['nombreComercial']
                    .invalid &&
                  formulario_registro_alianza.controls['nombreComercial']
                    .touched &&
                  formulario_registro_alianza.controls['nombreComercial'].errors
                    ?.required
                "
                class="text-danger ml-2"
              >
                Campo obligatorio *
              </small>
            </div>

            <div class="mt-2">
              <div class="form-group">
                <label
                  >Si eres Aliado de Seguros SURA favor de agregar tu número de
                  proveedor</label
                >
                <input
                  type="text"
                  formControlName="codProveedor"
                  class="form-control"
                  onkeypress="return (event.keyCode != 32 && ( (event.keyCode >= 48) && (event.keyCode <=57) ))"
                />
              </div>
            </div>

            <div class="mt-2">
              <p>
                Importante: Si eres aliado y no recuerda tu número de proveedor,
                solicítalo al correo
              </p>
              <a [href]="'mailto:mxproveedores@segurossura.com.mx'"
                >mxproveedores@segurossura.com.mx</a
              >
            </div>

            <!-- <div class="mt-2">
              <ngx-recaptcha2
                #captchaElem
                [siteKey]="siteKey"
                (success)="handleSuccess($event)"
                (expire)="handleExpire()"
                formControlName="recaptcha"
              >
              </ngx-recaptcha2>
            </div> -->
          </div>
          <!-- //////////////////////////////////////////////////// -->
          <!-- FORMULARIO PERSONA MORAL -->
          <div *ngIf="persona == 2">
            <div class="input-field">
              <input
                type="text"
                class="form-control text-upper"
                placeholder="RFC (*)"
                name="rfc"
                required
                [maxlength]="persona == 1 ? 13 : 12"
                formControlName="rfcMoral"
                onkeypress="return ((event.keyCode >= 48 && event.keyCode <=57) || (event.keyCode >=65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122)  || (event.keyCode == 209) || (event.keyCode == 241)) "
              />
              <div
                *ngIf="
                  formulario_registro_alianza.controls['rfcMoral'].invalid &&
                  formulario_registro_alianza.controls['rfcMoral'].touched
                "
              >
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['rfcMoral'].errors
                      ?.required
                  "
                >
                  Campo obligatorio *
                </small>
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['rfcMoral'].errors
                      ?.minlength
                  "
                >
                  RFC no válido
                </small>
              </div>
            </div>
            <div class="input-field">
              <input
                type="text"
                class="form-control"
                placeholder="Nombre Comercial (*)"
                name="nombreComercial"
                maxlength="100"
                formControlName="nombreComercial"
              />
            </div>
            <small
              *ngIf="
                formulario_registro_alianza.controls['nombreComercial']
                  .invalid &&
                formulario_registro_alianza.controls['nombreComercial']
                  .touched &&
                formulario_registro_alianza.controls['nombreComercial'].errors
                  ?.required
              "
              class="text-danger ml-2"
            >
              Campo obligatorio *
            </small>

            <div class="input-field">
              <input
                type="text"
                class="form-control"
                placeholder="Razón Social (*)"
                name="razonSocial"
                required
                maxlength="100"
                formControlName="razonSocial"
                value=""
              />
            </div>
            <div
              *ngIf="
                formulario_registro_alianza.controls['razonSocial'].invalid &&
                formulario_registro_alianza.controls['razonSocial'].touched
              "
            >
              <small class="text-danger ml-2"> Campo obligatorio * </small>
            </div>

            <div class="input-field">
              <app-date-picker
                placeholder="Fecha de Constitución (*)"
                [max]="hoy"
                [dateString]="dateString"
                (action)="dateText($event, persona)"
              ></app-date-picker>
            </div>
            <small
              *ngIf="!fecha_valida2 && fecha_tocada2"
              class="text-danger ml-2"
            >
              Fecha de Constitución no válida
            </small>

            <div class="form-group">
              <select
                style="
                  visibility: hidden;
                  position: absolute;
                  z-index: -100;
                  width: 0px;
                "
                name="nacionalidad"
                class="form-control"
              >
                <option value="" selected>Nacionalidad</option>

                <option
                  *ngFor="let nacionalidad of nacionalidades; let i = index"
                  [value]="nacionalidad.code"
                >
                  {{ nacionalidad.desc }}
                </option>
              </select>
              <div class="form-group" style="margin-top: 10px">
                <ng-selectize
                  name="selectNacionalidad"
                  [value]="''"
                  [config]="singleSelectConfig"
                  [options]="nacionalidades"
                  [placeholder]="'Nacionalidad'"
                  [formControl]="f.nacionalidad"
                  (click)="changeSelectSearch(f.nacionalidad)"
                  ngDefaultControl
                ></ng-selectize>
                <small
                  *ngIf="f.nacionalidad.invalid && f.nacionalidad.touched"
                  class="ml-2 text-danger"
                  >Nacionalidad no válida</small
                >
              </div>
            </div>

            <div class="input-field">
              <input
                type="email"
                class="form-control"
                placeholder="Correo electrónico (*)"
                name="email"
                required
                formControlName="email"
              />
              <div
                *ngIf="
                  formulario_registro_alianza.controls['email'].invalid &&
                  formulario_registro_alianza.controls['email'].touched
                "
              >
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['email'].errors
                      ?.required
                  "
                >
                  Campo obligatorio *
                </small>
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['email'].errors?.email
                  "
                >
                  Correo Electrónico no válido
                </small>
              </div>
            </div>
            <div class="input-field">
              <div class="input-icon-password">
                <div
                  class="help-password"
                  title="Su contraseña debe contener mínimo 8 caracteres, letras &#013;mayúscula y minúsculas, un número y un caracter especial (#?!@$%^&*-). &#013;Ejemplo:Prueba1@"
                >
                  <i class="fas fa-question-circle"></i>
                </div>
                <i
                  *ngIf="!show"
                  class="fas fa-eye-slash lock"
                  (click)="switchPass()"
                ></i>
                <i
                  *ngIf="show"
                  class="fas fa-eye lock"
                  (click)="switchPass()"
                ></i>
                <input
                  [type]="show ? 'text' : 'password'"
                  type="password"
                  class="form-control"
                  placeholder="Contraseña (*)"
                  required
                  name="password1"
                  minlength="8"
                  formControlName="password1"
                  (ngModelChange)="confirmPassword($event)"
                />
              </div>
              <div
                *ngIf="
                  formulario_registro_alianza.controls['password1'].touched &&
                  formulario_registro_alianza.controls['password1'].invalid
                "
              >
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['password1'].errors
                      ?.required
                  "
                >
                  Campo obligatorio *
                </small>
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['password1'].errors
                      ?.minlength
                  "
                >
                  Mínimo 8 caracteres *
                </small>
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['password1'].errors
                      ?.pattern
                  "
                >
                  Contraseña no válida *
                </small>
              </div>
            </div>
            <div class="input-field">
              <div class="input-icon-password">
                <i
                  *ngIf="!show"
                  class="fas fa-eye-slash lock"
                  (click)="switchPass()"
                ></i>
                <i
                  class="fas fa-eye lock"
                  *ngIf="show"
                  (click)="switchPass()"
                ></i>
                <input
                  [type]="show ? 'text' : 'password'"
                  type="password"
                  class="form-control"
                  placeholder="Repetir Contraseña (*)"
                  required
                  name="password2"
                  minlength="8"
                  formControlName="password2"
                  (ngModelChange)="confirmPassword($event)"
                />
              </div>
              <div
                *ngIf="
                  formulario_registro_alianza.controls['password2'].touched &&
                  formulario_registro_alianza.controls['password2'].invalid
                "
              >
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['password2'].errors
                      ?.required
                  "
                >
                  Campo obligatorio *
                </small>
                <small
                  class="text-danger ml-2"
                  *ngIf="
                    formulario_registro_alianza.controls['password2'].errors
                      ?.minlength
                  "
                >
                  Mínimo 8 caracteres *
                </small>
              </div>
              <div
                *ngIf="
                  formulario_registro_alianza.controls['password2'].touched
                "
              >
                <small class="text-danger ml-2" *ngIf="!iguales">
                  Las contraseñas deben coincidir
                </small>
              </div>
            </div>

            <div class="mt-2">
              <div class="form-group">
                <label
                  >Si eres Aliado de Seguros SURA favor de agregar tu número de
                  proveedor</label
                >
                <input
                  type="text"
                  formControlName="codProveedor"
                  class="form-control"
                  onkeypress="return (event.keyCode != 32 && ( (event.keyCode >= 48) && (event.keyCode <=57) ))"
                />
              </div>
            </div>

            <div class="mt-2">
              <p>
                Importante: Si eres aliado y no recuerda tu número de proveedor,
                solicítalo al correo
              </p>
              <a [href]="'mailto:mxproveedores@segurossura.com.mx'"
                >mxproveedores@segurossura.com.mx</a
              >
            </div>
            <!-- <div class="mt-2">
              <ngx-recaptcha2
                #captchaElem
                [siteKey]="siteKey"
                (success)="handleSuccess($event)"
                (expire)="handleExpire()"
                formControlName="recaptcha"
              >
              </ngx-recaptcha2>
            </div> -->
          </div>
          <!-- //////////////////////////////////////////////////// -->

          <div>
            <small *ngIf="mensajeError" class="ml-2 text-danger">
              {{ mensajeError }}</small
            >
          </div>
          <div *ngIf="errorMessage">
            <small class="ml-2 text-danger"> {{ errorMessage }}</small>
          </div>

          <div class="mt-2">
            <input type="checkbox" formControlName="avisoPrivacidad" />
            <a
              href="https://www.segurossura.com.mx/legales/aviso-de-privacidad/"
              target="_blank"
              style="margin-left: 5px"
              >He leído y acepto el Aviso de Privacidad</a
            >
          </div>
          <!-- SECCION DE BOTONES -->

          <div *ngIf="!waitingForApi" class="button-top mt-3 text-center">
            <div class="section-buttons" *ngIf="persona == 1">
              <a
                (click)="Back()"
                class="my-1 text-primary link get-back text-bold"
                >Regresar</a
              >
              <button
                type="submit"
                class="my-1 btn btn-primary"
                [disabled]="
                  !formulario_registro_alianza.valid ||
                  !fecha_valida1 ||
                  !iguales ||
                  !f.avisoPrivacidad.value
                "
              >
                CONTINUAR
              </button>
            </div>
            <div class="section-buttons" *ngIf="persona == 2">
              <a
                (click)="Back()"
                class="my-1 text-primary link get-back text-bold"
                >Regresar</a
              >
              <!--  -->
              <button
                type="submit"
                class="my-1 btn btn-primary"
                [disabled]="
                  !formulario_registro_alianza.valid ||
                  !fecha_valida2 ||
                  !iguales ||
                  !f.avisoPrivacidad.value
                "
              >
                CONTINUAR
              </button>
            </div>
          </div>
          <div *ngIf="waitingForApi" style="text-align: center">
            <div id="loading"></div>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="showMessage" class="text-medium text-secondary text-center">
      <p>
        Enviamos un correo electrónico <br />
        para activar tu cuenta de usuario<br />
      </p>
      <div class="button-top mt-5 text-center">
        <button class="btn btn-primary mt-1" [routerLink]="'/login-alianza'">
          FINALIZAR
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODALES -->

<ngx-smart-modal
  #errorModalMsj
  identifier="errorModalMsj"
  [closable]="false"
  [dismissable]="false"
  [customClass]="'nsm-centered modal-reject-contrac'"
  class="text-center"
>
  <div class="modal-icon-danger">
    <i class="fas fa-exclamation-circle"></i>
  </div>
  <div class="container-modal">
    <p>
      {{ modalMsjError }}
    </p>
  </div>
  <div>
    <button (click)="closeModal('errorModalMsj')" class="btn btn-primary">
      aceptar
    </button>
  </div>
</ngx-smart-modal>
